import React from 'react'
import style from './style.css'
export default class Spinner extends React.Component
{
    render()
    {
        return (
            <div className={style.spinner}>
                <div className={style.doubleBounce1}></div>
                <div className={style.doubleBounce2}></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/Spinner/Bounce/index.js